import {
  Box,
  Flex,
  IconButton,
  Stack,
  StackDivider,
  Text,
} from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';

export interface PosterAdditionalInfoRow {
  label: string;
  value: string;
}

interface PosterAdditionalInfoSectionProps {
  title: string;
  rows: PosterAdditionalInfoRow[];
  onBack: () => void;
}

export const PosterAdditionalInfoSection = ({
  title,
  rows,
  onBack,
}: PosterAdditionalInfoSectionProps) => (
  <Box
    position="absolute"
    inset="6% 7.5% 8% 7.5%"
    bg="#F2F2F7"
    borderRadius="28px"
    overflow="hidden"
    display="flex"
    flexDirection="column"
  >
    <Flex
      align="center"
      justify="center"
      position="relative"
      px={2}
      pt={7}
      pb={2}
      flexShrink={0}
    >
      <IconButton
        aria-label="Back"
        icon={<ChevronLeftIcon boxSize="18px" />}
        size="xs"
        variant="ghost"
        borderRadius="full"
        position="absolute"
        left={1}
        onClick={onBack}
      />
      <Text fontSize="12px" fontWeight="600" color="gray.900" noOfLines={1}>
        {title}
      </Text>
    </Flex>

    <Box flex={1} overflowY="auto" px={2} pt={3} pb={3}>
      <Box bg="white" borderRadius="12px" px={3}>
        <Stack spacing={0} divider={<StackDivider borderColor="gray.100" />}>
          {rows.map((row) => (
            <Box key={row.label} py="6px">
              <Text
                fontSize="11px"
                fontWeight="500"
                color="gray.900"
                textTransform="uppercase"
              >
                {row.label}
              </Text>
              <Text fontSize="10px" color="gray.500">
                {row.value}
              </Text>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  </Box>
);
